import React from "react"

import type { MetricRecord } from "@/metrics/runtime"

import type { MetricRecordData } from "@/types/metrics/contracts"

import { CustomAgentNeedsRepromptingConfig } from "../../configuration/components/CustomAgentNeedsRepromptingConfig"
import { AgentNeedsRepromptingMetricRecord } from "./AgentNeedsRepromptingMetricRecord"

export class CustomAgentNeedsRepromptingMetricRecord extends AgentNeedsRepromptingMetricRecord {
  get hasVersionedConfig() {
    return true
  }

  // TODO: Version tracking should use runtime_metadata once structured runtime metadata is implemented.
  // min_silence_gap_seconds should move from result to runtime_metadata.
  isMetricOutputCurrentVersion(_metricOutput: {
    result_json?: Record<string, unknown> | null
  }): boolean {
    return true
  }

  getVersionDiff(_metricOutput: {
    result_json?: Record<string, unknown> | null
  }): Array<{ field: string; current: string; previous: string }> {
    return []
  }

  renderEditorMetadata(
    metricRecordData: MetricRecordData,
    onChange: (metric: MetricRecordData) => void,
    textAreaRef?: React.RefObject<HTMLTextAreaElement>,
    editorContext?: Parameters<MetricRecord["renderEditorMetadata"]>[3],
  ): React.ReactNode {
    return (
      <div className="flex flex-col gap-4">
        <CustomAgentNeedsRepromptingConfig
          metricRecordData={metricRecordData}
          onChange={onChange}
        />
        {super.renderEditorMetadata(
          metricRecordData,
          onChange,
          textAreaRef,
          editorContext,
        )}
      </div>
    )
  }

  renderMetricType(): React.ReactNode {
    return "Agent Reprompting Delay"
  }
}
